import { useEffect, useRef, useState } from 'react'
import { View } from 'react-native'
import styled from 'styled-components'
import { absoluteFill } from '../../../style/commonStyles.js'
import Player from '../../video/Player'
import { AdSkipControl } from './AdSkipControl'
import { useVideoAdTracking } from './useVideoAdTracking.js'

const Container = styled(View)`
  background-color: #000;
  ${absoluteFill};
`

export const AdPlayer = ({
  advert,
  onRequestCloseAdvert,
  onPlayFeature,
  onPauseFeature,
  width = '100%',
  height = '100%',
  onRequestClose,
  shownControlsHeight,
  shownControlsDuration,
  notifyError,
  children,
  ...playerProps
}) => {
  const adPlayerContainer = useRef()

  useEffect(() => {
    onPauseFeature()
    return onPlayFeature
  }, []) // eslint-disable-line

  // Maintain seek time for skipping the ad outside the player, so it will
  // be updated even while the player controls are hidden.
  const [seekTime, setSeekTime] = useState(0)

  const trackingHandlers = useVideoAdTracking({
    advert,
    onRequestCloseAdvert,
    onProgress: setSeekTime,
    notifyError,
  })

  return (
    <Container ref={adPlayerContainer}>
      <Player
        width={width}
        height={height}
        url={advert.mediaFile.url}
        mime={advert.mediaFile.mime}
        shownControlsHeight={shownControlsHeight}
        shownControlsDuration={shownControlsDuration}
        onRequestClose={onRequestClose}
        skipStatusBarRestore
        adPlayerContainer={adPlayerContainer.current}
        {...playerProps}
        {...trackingHandlers}
      >
        {children}
      </Player>
      <AdSkipControl
        skipConfig={advert.skip}
        onSkip={trackingHandlers.onSkip}
        seekTime={seekTime}
        bottomOffset={shownControlsHeight}
      />
    </Container>
  )
}
